// extracted by mini-css-extract-plugin
module.exports = {"container":"AllPurchasesError_container__N764H","button":"AllPurchasesError_button__qMnLg"};